const baseUrl = "https://api.happysolutions.hu"
// const baseUrl = "http://localhost:8000/"

const baseUrlApi = `${baseUrl}api/`;

let ApiConfig = {
    baseUrl,
    baseUrlApi,
    token: null,
    login: `${baseUrlApi}login`,
    user: `${baseUrlApi}users`,
    apiURL: "https://api.happysolutions.hu",
    // apiURL: "http://localhost:8000",
    appURL: "https://admin.happygastro.hu",
};
export {ApiConfig};
